export const COOKIE_WOW_URL = 'https://cookiewow.com'
